import React, { useEffect, useRef, useState } from "react";
import EnhancePlusWorkflow from "./pages/EnhancePlusWorkflow/EnhancePlusWorkflow";
import EnhanceWorkflow from "./pages/EnhanceWorkflow/EnhanceWorkflow";
import CombinedReview from "./pages/combinedReview/CombinedReview";
import { resetPayload } from "./pages/EnhanceWorkflow/EnhanceWorkflowSlice";
import { resetEnhancePlusPayload, resetEnhancePlusResponse } from "./pages/EnhancePlusWorkflow/EnhancePlusWorkflowSlice";
import { resetCombinedPayload } from "./pages/combinedReview/CombinedReviewSlice";
import { useDispatch } from "react-redux";

const ACTIVE_MODULE_KEY = "activeModule";
const VALID_MODULES = ["Enhance Workflow", "Enhance Plus Workflow", "Combined Review"]; 

export default function WorkflowRouter() {

  const [activeModule, setActiveModuleState] = useState(() => {
    const stored = sessionStorage.getItem(ACTIVE_MODULE_KEY);
    return VALID_MODULES.includes(stored) ? stored : "Enhance Workflow";
  });

  const dispatch = useDispatch();
  const lastResetModule = useRef(null);
  const setActiveModule = (mod) => {
    sessionStorage.setItem(ACTIVE_MODULE_KEY, mod);
    setActiveModuleState(mod);
  };

  if (lastResetModule.current !== activeModule) {
    if (lastResetModule.current !== null) {
      dispatch(resetPayload());
      dispatch(resetEnhancePlusPayload());
      dispatch(resetCombinedPayload());
      dispatch(resetEnhancePlusResponse());
    }
    lastResetModule.current = activeModule;
  }

  if (activeModule === "Enhance Plus Workflow") {
    return <EnhancePlusWorkflow activeModule={activeModule} onModuleChange={setActiveModule} />;
  }
  if (activeModule === "Combined Review") {
    return <CombinedReview activeModule={activeModule} onModuleChange={setActiveModule} />;
  }
  return <EnhanceWorkflow activeModule={activeModule} onModuleChange={setActiveModule} />;
}